import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'birthDateYears'
})
export class BirthDateYearsPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: any, format?: string): any {
    if (!value){
      return '';
    }
    if (value.indexOf('*') !== -1) {
      return value;
    }
    const dob = new Date(value);
    const now = new Date();

    let year = now.getFullYear() - dob.getFullYear();
    let month = now.getMonth() - dob.getMonth();
    const days = now.getDate() - dob.getDate();

    if (days < 0) {
      month -= 1;
    }

    if (month < 0) {
      month += 12;
      year -= 1;
    }

    let transformResult = '(' + year + '.' + month + 'y)';

    if (format) {
      // Note: the current language (by the 'this.translateService.currentLang' expression) may not be supported
      //       by the DatePipe (see this comment from the DatePipe documentation:
      //          * Only the `en-US` locale data comes with Angular. To localize dates
      //          * in another language, you must import the corresponding locale data.
      //          * See the [I18n guide](guide/i18n#i18n-pipes) for more information.)
      transformResult = new DatePipe('en-US').transform(value, format) + ' ' + transformResult;
    }

    return transformResult;
  }

}
